import { ca } from '@cian/analytics';

export function trackBannerShow() {
  ca('event', {
    action: 'contract_ipoteka_show',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackBannerClick() {
  ca('event', {
    action: 'ipoteka_click',
    category: 'card',
    label: 'under_sale_contract',
    name: 'oldevent',
  });
}
